import { TextInput } from '@ordr-as/umami-react/form';
import { UnintegratedPaymentFields } from '../../../../../../generated-api';
import { useScreenSize } from '../../../../../context/ScreenSizeContext';
import { useState } from 'react';
import { DebouncedState } from 'use-debounce';

interface Props {
  autoFocus: boolean | undefined;
  dynamicFields: UnintegratedPaymentFields[] | undefined;
  dynamicFieldValues: { [key: string]: string };
  setDynamicFieldValues: React.Dispatch<
    React.SetStateAction<{
      [key: string]: string;
    }>
  >;
  setReference: DebouncedState<(value: string | undefined) => void>;
  giftCardSource: 'INTERNAL' | 'EXTERNAL';
}

const CheckoutUnintegratedPaymentFieldsFavritGiftCard = (props: Props) => {
  const { autoFocus, dynamicFields, dynamicFieldValues, setDynamicFieldValues, setReference, giftCardSource } = props;
  const { isPhone } = useScreenSize();
  const [textInput, setTextInput] = useState<string>(giftCardSource === 'INTERNAL' ? 'F-' : '');

  const handleReferenceInput = (newValue: string) => {
    setTextInput(newValue);
    setReference(newValue);
  };

  return (
    <>
      {dynamicFields?.map((dynamicField) => {
        if (dynamicField.name === 'reference') {
          return (
            <TextInput
              label={dynamicField.displayLabel}
              className="mb-4"
              required={dynamicField.required}
              fullWidth
              autoFocus
              key={dynamicField.displayLabel}
              value={textInput}
              onChange={handleReferenceInput}
            />
          );
        }

        return (
          <TextInput
            label={dynamicField.displayLabel}
            className="mb-4"
            autoFocus={autoFocus}
            fullWidth={isPhone}
            required={dynamicField.required}
            key={dynamicField.displayLabel}
            value={dynamicFieldValues[dynamicField.name]}
            onChange={(e) => {
              setDynamicFieldValues({ ...dynamicFieldValues, [dynamicField.name]: e.trimStart() });
            }}
          />
        );
      })}
    </>
  );
};

export default CheckoutUnintegratedPaymentFieldsFavritGiftCard;
